import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Counter, NewUserCounter, PaymentRefund, PaymentRefundGlobal, PaymentType, ResultSearchEngine, SelectCounterSessionBasketOffer, SelectCounterSessionBasketOfferString } from 'app/shared/models/class/counter/counter';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CounterService {

  constructor(private http: HttpClient) { }

  /* -------------------------------------------------------------------------- */
  /*                                     GET                                    */
  /* -------------------------------------------------------------------------- */

  getCounterSessionBasket(counterUserKey: number, userKey: number): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/counter/${counterUserKey}/${userKey}`);
  }

  getCounterEditSessionBasket(counterUserKey: number, userKey: number, bookingKey: number): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/counter/EditSessionBasket/${counterUserKey}/${userKey}/${bookingKey}`);
  }

  checkSessionBasketBookable(counterUserKey: number, userKey: number): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/counter/CheckSessionBasketBookable/${counterUserKey}/${userKey}`);
  }

  getCounterPriceOffer(counterUserKey: number, userKey: number): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/counter/Pricing/${counterUserKey}/${userKey}`);
  }

  getPaymentRefundList(bookingKey: number): Observable<PaymentRefundGlobal> {
    return this.http.get<PaymentRefundGlobal>(`${environment.apiUrl}/counter/PaymentList/${bookingKey}`);
  }

  getPaymentTypeList(): Observable<PaymentType[]> {
    return this.http.get<PaymentType[]>(`${environment.apiUrl}/counter/PaymentTypeList`);
  }

  /* -------------------------------------------------------------------------- */
  /*                                    POST                                    */
  /* -------------------------------------------------------------------------- */

  createNewUser(newUser: NewUserCounter) {
    return this.http.post(`${environment.apiUrl}/counter/CreateNewUser`, newUser);
  }

  createCounterBasketSession(counterUserKey: number, bookedSessionKey: number) {
    return this.http.post(`${environment.apiUrl}/counter/CreateCounterBasketSession/${counterUserKey}/${bookedSessionKey}`, null);
  }

  addToCounterSessionBasket(counterUserKey: number, userKey: number, offerKey: number) {
    return this.http.post(`${environment.apiUrl}/counter/AddToSessionBasket/${counterUserKey}/${userKey}/${offerKey}`, null);
  }

  counterSearchEngine(criteria: string, clubCode: string) {
    return this.http.post<ResultSearchEngine[]>(`${environment.apiUrl}/counter/Search/${criteria}/${clubCode}`, null);
  }

  /* -------------------------------------------------------------------------- */
  /*                                     PUT                                    */
  /* -------------------------------------------------------------------------- */

  updateCounterTraineeQuantity(counter: Counter) {
    return this.http.put(`${environment.apiUrl}/counter/UpdateTraineeQuantity`, counter);
  }

  updateCounterSession(counter: Counter) {
    return this.http.put(`${environment.apiUrl}/counter/UpdateSession`, counter);
  }

  updateSessionBasketTrainees(counterSessionBasketKey: number, traineeKeys: string) {

    const formData = new FormData();
    formData.append('counterSessionBasketKey', counterSessionBasketKey.toString());
    formData.append('traineeKeys', traineeKeys);

    return this.http.put(`${environment.apiUrl}/counter/UpdateSessionBasketTrainees`, formData);
  }

  selectCounterSessionBasketOffer(selection) {
    const formData = new FormData();
    formData.append('selectCounterSessionBasketOfferString', JSON.stringify(selection));

    return this.http.put(`${environment.apiUrl}/counter/SelectCounterSessionBasketOffer`, formData);
  }

  checkCounterSessionBasketComplete(selection: SelectCounterSessionBasketOffer) {
    const formData = new FormData();
    formData.append('selectCounterSessionBasketOfferString', JSON.stringify(selection));

    return this.http.put(`${environment.apiUrl}/counter/CheckCounterSessionBasketComplete`, formData);
  }

  applyCounterBasket(selection: SelectCounterSessionBasketOfferString) {

    const formData = new FormData();
    formData.append('selectCounterSessionBasketOfferString', JSON.stringify(selection));

    return this.http.put(`${environment.apiUrl}/counter/ApplyCounterBasket`, formData);
  }

  addPaymentRefund(payment: PaymentRefund) {
    return this.http.put(`${environment.apiUrl}/counter/AddPaymentRefund`, payment);
  }

  validateBasketCounter(basket) {
    return this.http.put(`${environment.apiUrl}/counter/CounterValidateBasket`, basket);
  }
}
